(function () {
  'use strict';

  var hub = document.querySelector('[data-deckaura-tools-server-i18n]');
  var language = String(document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  if (!hub || language === 'en' || hub.hasAttribute('data-deckaura-language-filtered')) return;

  var englishOnly = new Set([
    'attachment-style-quiz', 'aura-color-quiz', 'chakra-test', 'crystal-meanings',
    'destiny-matrix-calculator', 'dream-interpreter', 'i-ching-reading',
    'karmic-debt-calculator', 'love-calculator', 'name-numerology-calculator',
    'personal-year-calculator', 'should-i-text-him-tarot', 'mars-sign-calculator',
    'mercury-sign-calculator', 'chiron-sign-calculator', 'midheaven-calculator',
    'transit-chart-calculator', 'solar-return-chart-calculator',
    'astrocartography-calculator', 'nakshatra-calculator', 'sade-sati-calculator'
  ]);

  function pageSlug(value) {
    try {
      var path = new URL(value, window.location.origin).pathname;
      return path.split('/pages/')[1] || '';
    } catch (_) {
      return '';
    }
  }

  hub.querySelectorAll('a[data-tool-card]').forEach(function (card) {
    if (englishOnly.has(pageSlug(card.getAttribute('href')))) card.remove();
  });
  hub.querySelectorAll('[data-tool-category]').forEach(function (category) {
    if (!category.querySelector('a[data-tool-card]')) category.remove();
  });

  var count = hub.querySelectorAll('a[data-tool-card]').length;
  var eyebrow = hub.querySelector('.tlh__eyebrow');
  var proof = hub.querySelector('.tlh__hero-proof li:first-child strong');
  var search = hub.querySelector('#tlhSearch');
  if (eyebrow) eyebrow.textContent = eyebrow.textContent.replace(/^\s*\d+/, String(count));
  if (proof) proof.textContent = String(count);
  if (search) search.placeholder = search.placeholder.replace(/\d+/, String(count));

  document.querySelectorAll('script[type="application/ld+json"]').forEach(function (node) {
    var data;
    try { data = JSON.parse(node.textContent); } catch (_) { return; }
    if (!data || data['@type'] !== 'ItemList' || !Array.isArray(data.itemListElement)) return;
    data.itemListElement = data.itemListElement.filter(function (entry) {
      return !englishOnly.has(pageSlug(entry && entry.item));
    }).map(function (entry, index) {
      entry.position = index + 1;
      return entry;
    });
    data.numberOfItems = data.itemListElement.length;
    node.textContent = JSON.stringify(data);
  });

  hub.setAttribute('data-deckaura-language-filtered', String(count));
})();
